// In the top bar: is the sending window open right now (10:00–19:00 IST, never on Sunday, from Settings)?
// Campaigns send only while it is open.
import { Badge } from '@the-kit/ui'
import { useClock } from '@/features/settings'

export function WindowBadge() {
  const clock = useClock()
  if (!clock.data) return null
  const { window_open: open, send_from: from, send_to: to } = clock.data
  return (
    <span
      className="hidden sm:inline"
      title={`Sending window ${from}:00–${to}:00 IST, never on Sunday`}
      data-testid="window-badge"
    >
      <Badge tone={open ? 'success' : 'gray'}>{open ? 'window open' : 'window closed'}</Badge>
    </span>
  )
}
